(() => {
  const setup = () => {
    document.querySelectorAll('[data-gc-sticky-cart]').forEach((bar) => {
      if (bar.dataset.gcBound) return;
      const sectionId = bar.dataset.sectionId;
      const originalButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      const section = document.getElementById(`MainProduct-${sectionId}`);
      const stickyButton = bar.querySelector('[data-gc-sticky-submit]');
      const stickyLabel = bar.querySelector('[data-gc-sticky-label]');
      const stickyPrice = bar.querySelector('[data-gc-sticky-price]');
      if (!originalButton || !section || !stickyButton || !stickyLabel) return;
      bar.dataset.gcBound = 'true';
      const root = document.documentElement;
      const mobile = window.matchMedia('(max-width: 749px)');
      let pastButton = false;
      const syncVisibility = () => {
        const show = pastButton && mobile.matches && !document.body.classList.contains('overflow-hidden');
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', String(!show));
        root.classList.toggle('gc-purchase-bar-visible', show);
      };
      const syncState = () => {
        const current = document.getElementById(`ProductSubmitButton-${sectionId}`);
        if (!current) return;
        const busy = current.classList.contains('loading');
        stickyButton.disabled = current.disabled || current.getAttribute('aria-disabled') === 'true';
        stickyButton.setAttribute('aria-busy', String(busy));
        const label = current.querySelector('span')?.textContent.trim() || current.textContent.trim();
        stickyLabel.textContent = busy ? bar.dataset.loadingLabel : label;
        const price = document.getElementById(`price-${sectionId}`);
        const value = price?.querySelector('.price--on-sale .price-item--sale')
          || price?.querySelector('.price-item--regular');
        if (value && stickyPrice) stickyPrice.textContent = value.textContent.trim();
      };
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        syncVisibility();
      });
      visibilityObserver.observe(originalButton);
      const stateObserver = new MutationObserver(syncState);
      stateObserver.observe(section, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
      const bodyObserver = new MutationObserver(syncVisibility);
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      const sizeObserver = new ResizeObserver(() => {
        root.style.setProperty('--gc-purchase-bar-height', `${bar.offsetHeight}px`);
      });
      sizeObserver.observe(bar);
      mobile.addEventListener('change', syncVisibility);
      section.addEventListener('change', syncState);
      stickyButton.addEventListener('click', () => {
        const current = document.getElementById(`ProductSubmitButton-${sectionId}`);
        if (current && !current.disabled && current.getAttribute('aria-disabled') !== 'true') current.click();
      });
      const unload = (event) => {
        if (!event.target.contains(bar)) return;
        visibilityObserver.disconnect();
        stateObserver.disconnect();
        bodyObserver.disconnect();
        sizeObserver.disconnect();
        mobile.removeEventListener('change', syncVisibility);
        root.classList.remove('gc-purchase-bar-visible');
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      syncState();
      syncVisibility();
    });
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
